import React from "react";
import { Link, useLocation } from "react-router-dom";

interface AsideProps {
  isJurical?: any
}

const Aside: React.FC<AsideProps> = ({ isJurical }) => {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  return (
    <aside
      data-v-dde546dc=""
      className="el-aside app-sidebar "
      style={{ width: 250 }}
    >
      <ul
        data-v-f5844412=""
        role="menubar"
        className="app-sidebar__menu el-menu"
      >
        <Link to="/dashboard">
          <li
            className={
              splitLocation[1] === "dashboard"
                ? "el-menu-item is-active"
                : "el-menu-item"
            }
            style={{ paddingLeft: "20px" }}
          >
            <i data-v-f5844412="" className="icofont-settings icon-menu"></i>
            <span data-v-f5844412="">Кабинет</span>
          </li>
        </Link>

        <Link to="/profile">
          <li
            className={
              splitLocation[1] === "profile"
                ? "el-menu-item is-active"
                : "el-menu-item"
            }
            style={{ paddingLeft: 20 }}
          >
            <i data-v-f5844412="" className="icofont-id icon-menu"></i>
            <span data-v-f5844412="">Аккаунт</span>
          </li>
        </Link>

        <Link to="/doc">
          <li
            data-v-f5844412=""
            role="menuitem"
            tabIndex={-1}
            className={
              splitLocation[1] === "doc"
                ? "el-menu-item is-active"
                : "el-menu-item"
            }
            style={{ paddingLeft: 20 }}
          >
            <i
              data-v-f5844412=""
              className="icofont-law-document icon-menu"
            ></i>

            <span data-v-f5844412="">Договор</span>
          </li>
        </Link>
        {isJurical === 1 ?
          <Link to="/accounts">
            <li
              data-v-f5844412=""
              role="menuitem"
              tabIndex={-1}
              className={
                splitLocation[1] === "accounts"
                  ? "el-menu-item is-active"
                  : "el-menu-item"
              }
              style={{ paddingLeft: 20 }}
            >
              <i
                data-v-f5844412=""
                className="icofont-law-document icon-menu"
              ></i>

              <span data-v-f5844412="">Счета</span>
            </li>
          </Link>
          : null}


        <Link to="/report/traffic">
          <li
            className={
              splitLocation[1] === "report"
                ? "el-menu-item is-active"
                : "el-menu-item"
            }
            style={{ paddingLeft: 20 }}
          >
            <i
              data-v-f5844412=""
              className="icofont-chart-bar-graph icon-menu"
            ></i>

            <span data-v-f5844412="">Отчет по трафику</span>
          </li>
        </Link>
        <Link to="/traffic/stat">
          <li
            className={

              splitLocation[1] === "traffic"
                ? "el-menu-item is-active"
                : "el-menu-item"
            }
            style={{ paddingLeft: 20 }}
          >
            <i
              data-v-f5844412=""
              className="icofont-chart-bar-graph icon-menu"
            ></i>
            <span data-v-f5844412="">Графический отчет</span>
          </li>
        </Link>
      </ul>
    </aside>
  );
};

export default Aside;
